import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// Lote 131 (Robson, 27/10/2026): andamentos longos do processo ficam recolhidos (4 linhas) com "Ver mais /
// Ver menos", para a página não ficar enorme. Texto curto aparece inteiro, sem botão.
const LIMITE = 280;
export const ehLongo = (t) => {
  const s = String(t || "");
  return s.length > LIMITE || s.split("\n").length > 4;
};

export default function TextoRecolhivel({ texto, className = "", testid }) {
  const [aberto, setAberto] = useState(false);
  const longo = ehLongo(texto);
  return (
    <div data-testid={testid}>
      <p className={`mt-0.5 leading-relaxed whitespace-pre-line break-words ${longo && !aberto ? "line-clamp-4" : ""} ${className}`}>{texto}</p>
      {longo && (
        <button
          type="button"
          aria-expanded={aberto}
          data-testid={testid ? `${testid}-toggle` : undefined}
          onClick={() => setAberto((v) => !v)}
          className="mt-0.5 inline-flex items-center gap-1 min-h-[32px] text-xs font-semibold text-stone-600 hover:text-stone-900"
        >
          {aberto ? <><ChevronUp className="w-3.5 h-3.5" strokeWidth={2} /> Ver menos</> : <><ChevronDown className="w-3.5 h-3.5" strokeWidth={2} /> Ver mais</>}
        </button>
      )}
    </div>
  );
}
